<template>
  <main class="container mt-5 text-start" style="max-width: 720px">
    <h1 class="h4">{{ content.title }}</h1>
    <p>{{ content.message }}</p>
    <p>Bitte wenden Sie sich an die Administration Ihres Unternehmens oder den Nerdforce-Kundenservice.</p>
    <p v-if="error" role="alert">{{ error }}</p>
    <div class="d-flex gap-2 mb-4">
      <button v-if="kind !== 'Suspended' && kind !== 'Mfa'" class="btn btn-primary" :disabled="busy" @click="checkAgain">Erneut prüfen</button>
      <button v-if="kind === 'Mfa'" class="btn btn-primary" @click="stepUp">Mit zweitem Faktor bestätigen</button>
      <button class="btn btn-outline-secondary" @click="signOut">Abmelden</button>
    </div>
    <nav class="d-flex gap-3"><router-link to="/legal/imprint">Impressum</router-link><router-link to="/legal/privacy">Datenschutz</router-link><router-link to="/legal/terms">Nutzungsbedingungen</router-link></nav>
  </main>
</template>
<script setup>
import { computed, ref, defineProps } from "vue";
import { useRouter } from "vue-router";
import { useUserStore } from "@/stores/userStore";
import keycloak from "@/keycloak";
const props = defineProps({ kind: { type: String, required: true } });
const router = useRouter();
const store = useUserStore();
const busy = ref(false);
const error = ref("");
const content = computed(() => ({
  AssignmentPending: store.accessState === "CompanySelectionInvalid"
    ? { title: "Kein Zugriff auf die ausgewählte Firma", message: "Die ausgewählte Firma ist ungültig oder diesem Konto nicht zugewiesen. Es wurde keine andere Firma ausgewählt." }
    : { title: "Freischaltung ausstehend", message: "Ihre Anmeldung war erfolgreich. Für dieses Konto wurden noch keine wirksamen Anwendungsberechtigungen vergeben." },
  Suspended: { title: "Plattformzugriff gesperrt", message: "Der Zugriff auf diese Plattform wurde gesperrt. Der Status Ihres Keycloak-Kontos wird dadurch nicht geändert." },
  Unavailable: { title: "Sitzung derzeit nicht verfügbar", message: "Die Sitzung konnte nicht geladen werden. Bitte versuchen Sie es erneut." },
  Mfa: { title: "Zusätzliche Bestätigung erforderlich", message: "Für die Benutzer- und Berechtigungsverwaltung ist eine Anmeldung mit zweitem Faktor erforderlich." },
}[props.kind]));
async function checkAgain() {
  busy.value = true; error.value = "";
  try {
    await store.loadMe();
    await router.replace(store.accessState === "Active" ? "/" : "/assignment-pending");
  } catch (_) {
    if (store.accessState === "Suspended") await router.replace("/access-suspended");
    else error.value = store.accessState === "CompanySelectionInvalid"
      ? "Die ausgewählte Firma ist weiterhin nicht verfügbar."
      : "Die Sitzung ist weiterhin nicht verfügbar.";
  } finally { busy.value = false; }
}
function signOut() { return keycloak.logout({ redirectUri: window.location.origin }); }
function stepUp() { return keycloak.login({ redirectUri: window.location.origin + "/admin/users", acr: { essential: true, values: [process.env.VUE_APP_ADMINISTRATIVE_ACR || "2"] } }); }
</script>
